/// <amd-module name="Dashboards/WidgetHost/Helpers/DashboardsPanelManager" />
import { AddToDashboardPanel } from "Dashboards/AddToDashboard/AddToDashboardPanel";
import { DashboardWidgetProps } from "Dashboards/WidgetContracts/Internal/DashboardWidgetProps";
import { DashboardIdentification, WidgetCopyProps } from "Dashboards/WidgetContracts/Internal/WidgetHostProps";
import * as React from "react";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssLayoutManager } from "VSS/Platform/Layout";
import { publishEvent } from "VSS/Platform/Telemetry";

/** Responsible for delay loaded interactions with singleton panels used for Dashboard Scenarios. */
export interface IDashboardsPanelManager extends IVssService {
    /** Shows a dashboard picker panel, for copying a widget to a dashboard. If user chooses a dashboard, information is returned via onOk callback.
     * The caller is responsible for performing the copy behavior, as policy and notification UX can varies depending on if target is current dashboard.
     */
    copyWidget: (widgetProps: DashboardWidgetProps, onOk: (copyInformation: WidgetCopyProps) => void, onPanelDismiss: () => void, telemetryProps: IDashboardsPanelManagerTelemetryProps) => void;
}

interface IDashboardsPanelManagerTelemetryProps {
    parentPageName: string
}

class DashboardsPanelManager extends VssService implements IDashboardsPanelManager {
    public copyWidget(
        widgetProps: DashboardWidgetProps,
        onOk: (copyInformation: WidgetCopyProps) => void, 
        onPanelDismiss: () => void,
        telemetryProps: IDashboardsPanelManagerTelemetryProps
    ) {
        const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        layoutManager.renderCallout((onDismiss: () => void) => {
            return (
                <AddToDashboardPanel
                    isOpen={true}
                    onOk={(selectedDashboard: DashboardIdentification) => {
                        onOk({
                            sourceWidget: widgetProps,
                            destinationDashboard: selectedDashboard
                        });

                        publishEvent(this.pageContext, "Dashboards", "CopyWidgetToDashboard",{
                            source: telemetryProps.parentPageName,
                            widgetContributionId: widgetProps.contributionId,

                        })
                        onDismiss();
                    }}
                    onDismiss={() => {
                        onPanelDismiss();
                        onDismiss();
                    }}
                    widgetName={widgetProps.name}
                />
            );
        });
    }
}

Services.add("IDashboardsPanelManager", { serviceFactory: DashboardsPanelManager });
